// Este archivo contiene los IDs de los atributos definidos en el sistema.
export const WARRANTY = "WARRANTY";
export const CLIENT_WARRANTY = "CLIENT_WARRANTY";
export const IP_ADDRESS = "b393eef4-e764-4192-bb4c-4d3b106535bc";
export const MAC_ADDRESS = "9b9b35cb-3232-4dd3-94ab-7260fd1a3575";
